<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-no-ref title="" ref="thisModal" v-bind:onsave="doSave" size="modal-xs mx-4 mt-5 mt-md-4 mx-md-auto">
      <form class="login-formx" action="index.html" onsubmit="return false" id="loginform_tmp">
        <div class="card m-0 shadow-0 border-0" id="loginContainer">
          <div class="card-body pt-2">
            <div class="text-center mb-2">
              <i class="icon-reading icon-2x text-slate-300 border-slate-300 border-3 rounded-pill p-3 mb-2 mt-1"></i>
              <h5 class="mb-0">{{$t('login_easy_start')}}</h5>
              <span class="d-block text-muted">{{$t('login_enter_your_email')}}</span>
            </div>
            <div class="alert alert-danger alert-dismissible" v-if="errorMessage != ''">
              {{errorMessage}}. <!--Please try again later.-->
            </div>
            <div class="alert alert-success alert-dismissible" v-if="displayCreateSuccess == true">
              <span class="font-weight-semibold">Your account has been created</span>. Please use your cridentials to login.
            </div>

            <div class="form-group-feedback form-group-feedback-left">
              <input type="text" class="form-control" v-bind:placeholder="$t('email')" id="username" v-model="username" required="">
              <div class="form-control-feedback">
                <i class="icon-user text-muted"></i>
              </div>
            </div>
            <div class="mt-2 form-group">
              <button type="submit" class="btn btn-success btn-block" @click="authenticate">{{$t('email_sign_in')}}</button>
            </div>
            <!--<div class="text-center mt-1">
              <a href="#" @click="openRegister()">{{$t('register')}}</a>
            </div>
            <div class="text-center">
              <a href="#" @click="openForgotPassword()">{{$t('forgot_password')}}</a>
            </div>-->
          </div>
        </div>
      </form>

    </modal-no-ref>
    <ticker ref="ticker"></ticker>
  </div>

</template>

<script>
  import NuxFlow2 from "../nux/nux-flow2.vue";
  import ModalNoRef from "../modals/modal-no-ref.vue";
  import ticker from '../common/common-ticker.vue'

  var username = "";
  var errorMessage = "";
  var doRedirect = true;

  var doCancel = false;
  var displayCreateSuccess = false;

  export default {
    name: "login-with-tmp-email",
    components: {
      ModalNoRef,
      ticker,
      NuxFlow2
    },
    props: {
      user: {
        type: String,
        default: ""
      },
      querystring: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        username,
        errorMessage,
        doRedirect,
        displayCreateSuccess
      };
    },
    methods: {

      setDoRedirect(val) {
        this.doRedirect = val;
      },

      async authenticate() {
        var this_context = this;
        if (!$('#loginform_tmp').valid())
          return false;

        var data = {
          username: this.username,
          //domainUrl: location.href,
          //querystring: this.querystring,
        };
        this.$refs.ticker.start("loginContainer");
        try {
          // microservice check
          if (this.querystring.indexOf("microservice") !== -1) {
            this.$http.post('/api/Microservice/ValidateUser?' + this.querystring, data)
              .catch(error => {
                //this_context.errorMessage = error.response.status + " An error occurred";
                this_context.$refs.ticker.end("loginContainer");
                this_context.errorMessage = "An error occurred, please try again later";
              })
              .then(function (response) {
                console.log(response);
                if (response.data.ReturnCode == 0) {
                  this_context.errorMessage = response.data.DetailedMessage;
                  this_context.$refs.ticker.end("loginContainer");
                } else {
                  vm.$root.$emit('doLoadMicroservice', response.data);
                  this_context.close();
                }
              });
          } else {
            data.querystring = this.querystring;
            Vue.prototype.$hostname = "";
            this.$http.post('/authentication/TempLoginWithEmail', data)
              .catch(error => {
                //this_context.errorMessage = error.response.status + " An error occurred";
                this_context.$refs.ticker.end("loginContainer");
                this_context.errorMessage = "An error occurred, please try again later";
              })
              .then(function (response) {
                location.href = response.data;
              });
          }
        }
        catch (err) {
          alert('some error:' + err)
          this.$refs.ticker.end("loginContainer");
        }
      },
      getTranslatedText() {
        return this.$t('validation_field_success')
      },
      open(selectedSite) {
        this.$refs.thisModal.open();
        if (selectedSite != null) {
          this.setSelectedSite(selectedSite);
        }
      },
      close() {
        this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      initValidation() {
        var validator = $('#loginform_tmp').validate({
          ignore: 'input[type=hidden], .select2-search__field', // ignore hidden fields
          errorClass: 'validation-invalid-label',
          successClass: 'validation-valid-label',
          validClass: 'validation-valid-label',
          highlight: function (element, errorClass) {
            $(element).removeClass(errorClass);
          },
          unhighlight: function (element, errorClass) {
            //element.remove();
            $(element).siblings().forEach(el => {
              if (el.hasClass(errorClass)) {
                el.removeClass(errorClass);
                el.addClass(successClass);
              }
            });
          },
          success: function (label) {
            //label.addClass('validation-valid-label').text(this.getSuccessText); // remove to hide Success message
          },
          showErrors: function (errorMap, errorList) {
            if (this.numberOfInvalids() > 0)
              this.defaultShowErrors();
          },
          // Different components require proper error label placement
          errorPlacement: function (error, element) {

            // Unstyled checkboxes, radios
            if (element.parents().hasClass('form-check')) {
              error.appendTo(element.parents('.form-check').parent());
            }

            // Input with icons and Select2
            else if (element.parents().hasClass('form-group-feedback') || element.hasClass('select2-hidden-accessible')) {
              error.appendTo(element.parent());
            }

            // Input group, styled file input
            else if (element.parent().is('.uniform-uploader, .uniform-select') || element.parents().hasClass('input-group')) {
              error.appendTo(element.parent().parent());
            }

            // Other elements
            else {
              error.insertAfter(element);
            }
          },
          rules: {

          },
          messages: {
            username: this.$t('enter_your_username'),
          }
        });
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.$root.$on('display_login', this.open);
      window.$eventBus.$on('refresh_login', this.refreshOpen, false);
      if (this.state == "open") {
        this.open();
      }
      this.initValidation();
    },
    created() {

    },
  };

</script>

<style>
  .validation-valid-label {
    margin: auto;
    margin-bottom: 30px !important;
    padding-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login-with-tmp-email.vue